import { Fragment, useState, useMemo } from 'react';
import { useParams } from "react-router";
import { connect } from "react-redux";
import Loading from "components/Loading";
import { useTranslation } from "react-i18next";
import { ReactTableDataGrid } from "components/Table";
import useCallApi from "hook/useCallApi";
import { getVideosByShop } from "actions/spyAdvancedActions";
import { heightRow } from "../../constant";
import useColumnTableVideosByShop from "../../hooks/useColumnTableVideosByShop";

const limit = 20;

function Videolist({ getVideosByShop }) {
    const { t } = useTranslation();
    const { seller_id } = useParams();
    const [page, setPage] = useState(1);
    const params = useMemo(() => ({ page, per_page: limit, seller_id }), [page, seller_id]);
    const { data, loading } = useCallApi(getVideosByShop, params);
    const columns = useColumnTableVideosByShop(heightRow);

    const onTableChanged = ({ page }) => {
        if (page) setPage(page);
    };

    return (
        <Fragment>
            <Loading isLoading={loading} />
            <div className="card mt-5 mb-5 mb-xl-10">
                <div className="card-header border-0 cursor-pointer" role="button" data-bs-toggle="collapse" data-bs-target="#kt_account_profile_details" aria-expanded="true" aria-controls="kt_account_profile_details">
                    <div className="card-title m-0">
                        <h3 className="fw-bold m-0">{t("Video List")}</h3>
                    </div>
                </div>
                <div className="card-body">
                    <ReactTableDataGrid
                        tableName="videoList"
                        idProperty="_id"
                        columns={columns}
                        rowData={data?.data || []}
                        pageNumber={page}
                        gridOptions={{
                            rowHeight: heightRow,
                            reactiveCustomComponents: true,
                        }}
                        paginationPageSize={limit}
                        totalSize={data?.meta?.total || 0}
                        emptyText={"No data!"}
                        isSearchText={false}
                        onTableChanged={onTableChanged}
                        height="calc(100vh - 300px)"
                    />
                </div>
            </div>
        </Fragment>
    );
}

const mapStateToProps = state => ({
});
const mapDispatchToProps = {
    getVideosByShop
}

export default connect(mapStateToProps, mapDispatchToProps)(Videolist);